// Frontend/src/lib/paymentLabels.ts
//
// The display names for the invoice enums. Kept out of PaymentBits.tsx so
// that file exports components and nothing else — a mixed module breaks
// React Fast Refresh, which quietly turns every edit into a full reload.

import { useLanguage } from "@/contexts/LanguageContext";
import type { InvoiceStatus } from "@/api/payments";

/**
 * Spelled-out keys, never a template literal: check-i18n.py only matches
 * string-literal keys, so a computed one can go missing without CI noticing
 * and then renders as its own name in the UI.
 */
export function usePaymentLabels() {
  const { t } = useLanguage();
  return {
    status: {
      DRAFT: t("hoa.payments.status.draft"),
      SENT: t("hoa.payments.status.sent"),
      UNPAID: t("hoa.payments.status.unpaid"),
      PARTIALLY_PAID: t("hoa.payments.status.partiallyPaid"),
      PENDING_VERIFICATION: t("hoa.payments.status.pendingVerification"),
      PENDING_HOA_TRANSFER: t("hoa.payments.status.pendingHoaTransfer"),
      PAID: t("hoa.payments.status.paid"),
      CANCELLED: t("hoa.payments.status.cancelled"),
    } as Record<InvoiceStatus, string>,
    waiting: {
      NOBODY: t("hoa.payments.waiting.nobody"),
      RESIDENT: t("hoa.payments.waiting.resident"),
      YOU: t("hoa.payments.waiting.you"),
      PLATFORM: t("hoa.payments.waiting.platform"),
      SETTLED: t("hoa.payments.waiting.settled"),
    },
  };
}

export type PaymentLabels = ReturnType<typeof usePaymentLabels>;
